import { EpaGridProps } from "./EpaGridProps";
import { FetchGrid } from "./FetchGrid";
import { NoFetchGrid } from "./NoFetchGrid";

const Grid = (props: EpaGridProps) => {
  const {
    fetchUrlFunction,
    formatFunction,
    formatResponseFunction,
    enablePagination,
    enableQuickFind,
    columns,
    data,
    searchText,
    orderBy,
    exportToCsvFunction,
    defaultRecordsPerPage,
  } = props;

  if (!fetchUrlFunction) {
    return <NoFetchGrid columns={columns} data={data} />;
  } else {
    return (
      <FetchGrid
        columns={columns}
        data={data}
        fetchUrlFunction={fetchUrlFunction}
        formatFunction={formatFunction}
        formatResponseFunction={formatResponseFunction}
        enablePagination={enablePagination}
        enableQuickFind={enableQuickFind}
        searchText={searchText}
        orderBy={orderBy}
        exportToCsvFunction={exportToCsvFunction}
        defaultRecordsPerPage={defaultRecordsPerPage}
      />
    );
  }
};

export { Grid };
